import { defineNuxtPlugin } from '#app/nuxt';
import { applySchemaOverrides } from '#layers/workspace/rstore/overrides/apply-overrides';
import { useWorkspaceSchemaStore } from '#layers/workspace/stores/workspace-schema';

export default defineNuxtPlugin(() => {
	useWorkspaceSchemaStore().onBeforeHydrate(applySchemaOverrides);
});
